/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Authorizationurl1Inputs */

const en_entity_authorizationurl1 = /** @type {(inputs: Entity_Authorizationurl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorization URL`)
};

const de_entity_authorizationurl1 = /** @type {(inputs: Entity_Authorizationurl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisierungs-URL`)
};

/**
* | output |
* | --- |
* | "Authorization URL" |
*
* @param {Entity_Authorizationurl1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_authorizationurl1 = /** @type {((inputs?: Entity_Authorizationurl1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Authorizationurl1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_authorizationurl1(inputs)
	return de_entity_authorizationurl1(inputs)
});
export { entity_authorizationurl1 as "entity_authorizationUrl" }